import { Plugin, PluginKey } from 'prosemirror-state';
import { EditorView, NodeView } from 'prosemirror-view';
import { Node as ProseNode } from 'prosemirror-model';
import ReactDOM from 'react-dom/client';
import React from 'react';
import { InlineNote } from 'src/components/Cards/InlineNote';

const referenceNodeViewPluginKey = new PluginKey('referenceNodeView');

export const referenceNodeViewPlugin = (): Plugin =>
  new Plugin({
    key: referenceNodeViewPluginKey,
    props: {
      nodeViews: {
        reference(node: ProseNode, _view: EditorView, _getPos: () => number | undefined): NodeView {
          let currentNode = node;
          const dom = document.createElement('span');
          dom.className = 'prosemirror-reference-node-view';
          dom.setAttribute('contenteditable', 'false');

          const root = ReactDOM.createRoot(dom);

          const render = (): void => {
            const { noteId, noteName, noteType, text, textStart, textEnd } = currentNode.attrs;

            root.render(
              React.createElement(InlineNote, {
                note: {
                  id: noteId,
                  title: noteName || 'Untitled Note',
                  type: (noteType || 'takeaway') as 'takeaway' | 'source' | 'annote',
                },
                textReference: text || undefined,
                textStart: textStart != null ? textStart : undefined,
                textEnd: textEnd != null ? textEnd : undefined,
              }),
            );
          };

          render();

          return {
            dom,
            update: (updatedNode: ProseNode): boolean => {
              if (updatedNode.type !== currentNode.type) return false;
              if (updatedNode.attrs.noteId !== currentNode.attrs.noteId) return false;
              currentNode = updatedNode;
              render();
              return true;
            },
            destroy: (): void => {
              // Defer unmounting to avoid React 18 concurrent rendering conflicts
              queueMicrotask(() => {
                root.unmount();
              });
            },
            ignoreMutation: (): boolean => true, // Don't react to DOM mutations
            stopEvent: (): boolean => false, // Allow events to propagate
          };
        },
      },
    },
  });
